<template>
  <div class="payment-successful">
    <el-card class="success-card">
      <div class="success-content">
        <!-- 成功图标 -->
        <div class="success-icon">
          <i class="el-icon-success"></i>
        </div>

        <!-- 成功标题 -->
        <h2 class="success-title">支付成功</h2>
        
        <!-- 成功提示 -->
        <p class="success-message">恭喜您，会员支付已完成！</p>

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <el-button size="large" @click="goToHome">
            返回首页
          </el-button>
          <el-button type="primary" size="large" @click="goToMemberCenter">
            查看会员信息
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'PaymentSuccessful',

  methods: {

    /**
     * 返回首页
     */
    goToHome() {
      this.$router.push('/')
    },

    /**
     * 前往会员中心
     */
    goToMemberCenter() {
      this.$router.push('/user/member-type-select')
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-successful {
  min-height: 100vh;
  padding: 60px 20px;
  //background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  .success-card {
    max-width: 600px;
    width: 100%;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

    .success-content {
      text-align: center;
      padding: 20px;

      .success-icon {
        margin-bottom: 24px;

        i {
          font-size: 80px;
          color: #67c23a;
          animation: scaleIn 0.5s ease-out;
        }
      }

      .success-title {
        margin: 0 0 12px 0;
        font-size: 32px;
        color: #303133;
        font-weight: 600;
      }

      .success-message {
        margin: 0 0 32px 0;
        font-size: 16px;
        color: #606266;
      }

      .action-buttons {
        display: flex;
        justify-content: center;
        gap: 16px;

        .el-button {
          min-width: 140px;
        }
      }
    }
  }
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .payment-successful {
    padding: 40px 16px;

    .success-card {
      .success-content {
        padding: 16px;

        .success-icon i {
          font-size: 64px;
        }

        .success-title {
          font-size: 26px;
        }

        .success-message {
          font-size: 14px;
        }

        .action-buttons {
          flex-direction: column;
          gap: 12px;

          .el-button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
